export interface NavSection {
  id: string
  label: string
  description: string
}

export const navSections: NavSection[] = [
  { id: 'top', label: 'Home', description: 'Licensed, insured, family-owned for 20 years' },
  {
    id: 'transformation',
    label: 'The A&J Effect',
    description: 'Before and after a real restoration',
  },
  {
    id: 'why',
    label: 'Why Contractors Fail',
    description: 'The three types — and which one we are',
  },
  { id: 'family', label: 'Our Family', description: 'The people behind the name, 20 years in' },
  { id: 'why-aj', label: 'What You Get', description: 'Licensing, honest pricing, workmanship' },
  { id: 'services', label: 'Services', description: 'Plaster, remodels, tile, coping' },
  { id: 'gallery', label: 'Project Gallery', description: '9 real backyards we finished' },
  { id: 'video', label: 'See It In Motion', description: 'Two videos from real A&J jobs' },
  { id: 'process', label: 'Our Process', description: 'Estimate to fill in 3–4 weeks' },
  { id: 'reviews', label: 'Reviews', description: 'A perfect 5.0 on Google' },
  {
    id: 'service-area',
    label: 'Service Area',
    description: 'The Houston-area cities we cover',
  },
  { id: 'faq', label: 'FAQ', description: 'Cost, timeline, and warranty answers' },
  { id: 'contact', label: 'Free Estimate', description: 'Call or text — no pressure, no tricks' },
]

export const quickLinks = ['why', 'services', 'process', 'reviews', 'faq']
